import { Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { Router } from '@angular/router';
import { Update, Company, Project, User, Log } from 'api/models';
import { NavParams, ModalController, AlertController, LoadingController, ToastController, Content, ItemSliding, VirtualScroll, InfiniteScroll, ActionSheetController } from 'ionic-angular';
import { Updates, Users, Logs, Activities } from 'api/collections';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { App } from "ionic-angular";

import { LogType, LogCategories, Activity } from 'api/models';
import * as permissions from '../../services/permissions';
import { AugmentedActivity, ActivityService } from '../../services/activityData';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';

import { HttpService } from '../../services/httpService';

import { ActivityMenuComponent } from '../../components/activity-menu/activity-menu';
import { LogMenuComponent } from '../../components/log-menu/log-menu';

import { FilterMenuModal } from '../../directives/filter_menu/filter_menu.component.ts';
import { FilterSection, FilterOption } from './types';

import { ActivityLogsPage } from '../activity-logs/activity-logs';
import { ActivityDetailsPage } from '../activity-details/activity-details';

import { ISDEV, APP_TITLE } from "../../services/config";
import { SharedService } from '../../services/sharedService';
import { CalendarModal } from 'ion2-calendar';

import { Storage } from '@ionic/storage';
import { AuthenticationService } from '../../services/congito';

import {
  getDayVsScheduledStart,
  getDurationDelta,
  getFinishDelta,
  getStartDelta,
  daysBetween,
  getRemainingDurationInProgressProjectedFinish,
  getRemainingDurationInProgressFinishDelta,
  getRemainingDurationInProgressProjectedDuration,
  getRemainingDurationInProgressDurationDelta,
  getPercentCompleteInProgressProjectedFinish,
  getPercentCompleteInProgressFinishDelta,
  getPercentCompleteInProgressProjectedDuration,
  getPercentCompleteInProgressDurationDelta,
  getDayVsScheduledEnd,
  calculateProjectedFinish,
  calculateProjectedDuration,
} from '../../services/p6calendar';
import moment = require('moment');
import momentTz = require('moment-timezone');
import { NewLogComponent } from '../new-log/new-log';
import { LogView } from '../log-view/log-view';
import { conformToMask } from 'angular2-text-mask';
import { AddProjectUserComponent } from '../add-project-user/add-project-user';
import { NewUpdateComponent } from '../new-update/new-update';
var ProgressBar = require('progressbar.js')

const paginationLevel = 200000;

const activate = false;

type SortField = 'actualStart' | 'actualFinish' | 'activityName' | 'totalFloat' | 'projectLateness';
type ActivityFilter = {
  id: 'activityStatus',
  type: 'normal',
  selectedValues: Array < 'TK_NotStart' | 'TK_Active' | 'TK_Complete' > ,
} | {
  id: 'taskType',
  type: 'normal',
  selectedValues: Array < 'TT_Task' | 'TT_Mile' | 'TT_FinMile' > ,
} | {
  id: 'criticality',
  type: 'normal',
  selectedValues: Array < true | false | undefined > ,
} | {
  id: 'isFlagged',
  type: 'normal',
  selectedValues: Array < true | false | undefined > ,
} | {
  id: 'code',
  type: 'normal',
  selectedValues: Array < number > ,
} | {
  id: 'touchedThisPeriod',
  type: 'normal',
  selectedValues: Array < true | false | undefined > ,
};

export type SortOptions = Array<{
  label: string,
  value: string,
  selected: boolean
}>;

const DEFAULT_FILTER_SECTIONS: Array < FilterSection > = [{
    id: 'activityStatus',
    label: 'Activity Status',
    multiselect: true,
    isCollapsed: true,
    options: [
      { value: 'TK_NotStart', label: 'Not Started' },
      { value: 'TK_Active', label: 'In Progress' },
      { value: 'TK_Complete', label: 'Completed' },
    ]
  },
  {
    id: 'taskType',
    label: 'Activity Types',
    multiselect: true, // should be true
    isCollapsed: true,
    options: [
      { value: 'TT_Task', label: 'Tasks' },
      { value: 'TT_Mile', label: 'Start Milestones' },
      { value: 'TT_FinMile', label: 'Finish Milestones' },
    ],
  },
  {
    id: 'criticality',
    label: 'Critical',
    multiselect: false,
    isCollapsed: true,
    options: [
      { value: 'Y', label: 'Critical' },
      { value: 'N', label: 'Not Critical' },
    ],
  },
  {
    id: 'isFlagged',
    label: 'Flagged',
    multiselect: false,
    isCollapsed: true,
    options: [
      { value: true, label: 'Flagged' },
      { value: false, label: 'Not Flagged' },
    ],
  },
  {
    id: 'containsLog',
    label: 'Activity Logs',
    multiselect: false,
    isCollapsed: true,
    options: [
      { value: true, label: 'Contains Log' },
      { value: false, label: 'No Log' },
    ],
  },
  {
    id: 'touchedThisPeriod',
    label: 'Changed This Period',
    multiselect: false,
    isCollapsed: true,
    options: [
      { value: "changed", label: 'Changed' },
      { value: "unchanged", label: 'Not Changed' },
    ],
  },
];


function getHeaderForLevel(record, level) {
  if(record.wbsHeaders) {
    const header = record.wbsHeaders.find(header => header.level === level)
    return header ? header.TITLE : null
  }
  return null;
}
const DEFAULT_SORT_OPTIONS: SortOptions = [{
  value: 'actualStart',
  label: 'Start Date',
  selected: true
},
// {
//   value: 'actualFinish',
//   label: 'Finish Date',
//   selected: false
// },
{
  value: 'totalFloat',
  label: 'Total Float',
  selected: false
}, {
  value: 'activityName',
  label: 'Activity Name',
  selected: false
}];


@Component({
  templateUrl: 'activities.html',
  selector: 'activities'
})
export class ActivityListPage implements OnInit {
  public isDev = ISDEV;
  @ViewChild(Content) content: Content;
  @ViewChild('virtualScroll', { read: VirtualScroll }) virtualScroll: VirtualScroll;
  @ViewChild('slidingItem') slidingItem: ItemSliding;
 // @ViewChild(Content) pageTop: Content;
  @Input() sortOptions: SortOptions;
  @Input() sortAsc: boolean;
  @Input() sortField: string;
  @Input() getSortValueLabel: Function;
  @Output() onToggleSortOrder = new EventEmitter();
  storedFilterMap:any={};
  logs: Array<Log & { updateId?: string, update?: Update }>;
  activities: any[] = [];
  showSort:boolean=true;
  archivedUpdates: Update[];
  originalActivities: any[] = [];
  hideAll: boolean;
  selectedUpdate: Update;
  project: Project | void; //holds Project info for activity list
  nextProject: Project | void; //holds Project info for activity list
  company: Company | void;
  projects = []; //need to remove after testing and removal of existing projects functions
  viewerHasActivities: boolean;
  viewAsCompanyAdmin: boolean;
  userIdToView: string | void;
  useOwnHeader: boolean | void;
  isLoadingActivities: boolean;
  loadedUpdateId: string | void;
  updatedActivities: any = {};
  showPage: 'activity' | 'prompts';
  //Hour count from update calendar
  //hourCount: number;
  isProjectManager: boolean;
  isCompanyAdmin: boolean;
  isSuperAdmin: boolean;
  filters: any = {};
  filterText ? : string;
  wipFilterText ? : string;
  isShowingTextFilter: boolean;
  subCodes: any[] = [];
  filterMenuModal: any;
  filterCodeSections: Array < any /*FilterSection*/ > ; // these are the custom filters selected when the update is created
  filterSections: Array < FilterSection > ; // these are the active filters
  wipFilterSections: Array < any /*FilterSection*/ > ; // these are the filters that you edit in the popup
  selectedUser: User;
  wbsAccordion: any;
  activityCodesArray: Array < any > ; //need to initialize size inside of the callback function
  activitySubCodesArray: any[]; //need to initialize size inside of the callback function
  limit: number = 0;
  currentUpdateId: string;
  filterCodes: any[] = [];
  isInitialized: boolean;
  canLoadMore: boolean = true;
  previousUpdateId: string;
  activity: Activity;
  getDayVsScheduledStart: number;
  getDurationDelta: number;
  getFinishDelta: number;
  finishDays: number;
  projectMembers?: User[];
  canAddUsers: boolean;
  getStartDelta: number;
  getRemainingDurationInProgressProjectedFinish: number;
  getRemainingDurationInProgressFinishDelta: number;
  getRemainingDurationInProgressProjectedDuration: number;
  getRemainingDurationInProgressDurationDelta: number;
  getPercentCompleteInProgressProjectedFinish: number;
  getPercentCompleteInProgressFinishDelta: number;
  getPercentCompleteInProgressProjectedDuration: number;
  getPercentCompleteInProgressDurationDelta: number;
  getDayVsScheduledEnd: number;
  calculateProjectedFinish: number;
  calculateProjectedDuration: number;
  baselineRemainingDuration: number;
  percentComplete: number;
  workDays: any;
  exceptionDays: any;
  day: Date;
  hrCount: number;
  selectedActivity:Activity;
  user:any;
  update:any;
  durationOptions:any;
  newRd:any=0;
  viewer?: Meteor.User;
  members?: Array<User>;
  memberCanAct:any={};
  showProfileMap: Object={};
  canRemoveUsers: boolean;
  hasPMDashboardTab:boolean=false;
  wbs:boolean=true;
  defaultSelection: any=0;
  i = 0
  hideActivityCountInit: boolean=true;
  hideActivityCount: boolean=true;
  // End ActivityBarHeader
  bar:any;
  barloading:any;
  bardirection=false;
  callsRunning:Array<any>=[];
  startEditsRunning:Array<any>=[];
  finishEditsRunning:Array<any>=[];
  durationEditsRunning:Array<any>=[];
  

  constructor(
    private _app: App,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private sharedService: SharedService,
    private storage: Storage,
    public httpService: HttpService,
    public companyService: CompanyService,
    private activityService: ActivityService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService,
    private actionSheetCtrl: ActionSheetController,
    private router: Router
  ) {
    this.showSort=true
    this.activities = [];


    // ActivityBarHeader
    this.sortAsc = true;
    this.sortField = 'actualStart';
    this.filterText = undefined;
    this.wipFilterText = undefined;
    this.isShowingTextFilter = false;
    this.isLoadingActivities = true;
    this.loadedUpdateId = undefined;
    this.filterSections = DEFAULT_FILTER_SECTIONS;
    this.sortOptions = DEFAULT_SORT_OPTIONS;
    this.userIdToView = null;
    this.subCodes = [];
    this.filterCodes = [];
    this.filters = {};
    this.showPage = 'activity';
    this.defaultSelection = 0;

    
    // WBS Headers
    this.navParams.get('wbsKey');
    this.sharedService.logUpdate.subscribe(
      (activity: any) => {
      console.log('ACTIVITY', activity)
        /*
        MeteorObservable.call("getActivity",
          activity._id
        ).subscribe({
          next: (res: any) => {
            if(this.isDev == true) { console.log("result, result", res) }
            this.activities = (this.activities || []).map(existingActivity => {
              if(existingActivity._id === res._id) {
                this.updatedActivities[activity._id] = { ...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              }
              return existingActivity;
            }) || [];
            this.viewerHasActivities = this.activities && (this.activities.length > 0);
            this.isLoadingActivities = false;
            this.loadedUpdateId = this.currentUpdateId;

          },
          error: (e: Error) => {
            if(this.isDev == true) { console.log("importnant error", e) }
          }
        });
        */
        this.httpService.MeteorCall('getActivity', activity._id)
          .then((res: any) => {
            if(this.isDev == true) { console.log("result, result", res) }
            this.activities = (this.activities || []).map(existingActivity => {
              if(existingActivity._id === res._id) {
                this.updatedActivities[activity._id] = { ...this.activityService.getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              }
              return existingActivity;
            }) || [];
            this.viewerHasActivities = this.activities && (this.activities.length > 0);
            this.isLoadingActivities = false;
            this.loadedUpdateId = this.currentUpdateId;
          })
          .catch((e: Error) => {
            this.isLoadingActivities = false;
            if(this.isDev == true) { console.log("importnant error", e) }
          });
      });
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
     this.content.resize();
  }
  limit99(event){
    if(this.newRd.toString().length>1 || event.key==="-"){
      event.preventDefault()
    }

  }
  noNegativeOrDecimal(event){
    if((!this.newRd && event.key=="0") || event.key==="-" || event.key==="."){
      event.preventDefault()
    }
  }
  addUpdate(): void {
    if(!this.project) {
      return;
    }
    const modal = this.modalCtrl.create(NewUpdateComponent, { projectId: this.project._id }, { enableBackdropDismiss: false });
    modal.present();
    this.router.navigate([this.project.name, 'noActiveUpdate', 'setupNewUpdate']);

    modal.onDidDismiss(async () => {
      const loader = this.loadingCtrl.create({
        content: "Please wait...",
        enableBackdropDismiss: true,
      });
      loader.present();
      await this.mainSubscription().then(()=>this.httpService.privateLoopAction(true))
        .then(()=>this.mainSubscription())
      // await this.httpService.refreshSubscriptions();
      // await this.populateActivities()
      // await this.httpService.refreshSubscriptions();
      // await this.mainSubscription().then(()=>this.httpService.privateLoopAction(true))
      //   .then(()=>this.mainSubscription())
      //   await this.populateActivities()
      // this.sharedService.projectChanged.emit({...this.project, goToAppHome:true});

      setTimeout(()=>{
        loader.dismiss();
      }, 1000)
      
      // if (this.project) {
      //   this.router.navigate([this.project.name, 'activities']);
      // }
    });
  }

  preActivitySearch(){
    if(this.selectedUpdate){
      this.callsRunning.push("");
      // try{
      //   const duration=1400;
      //   if(!this.bar){
          
      //     this.bar = new ProgressBar.Line("#loadProgress", {
      //       strokeWidth: 4,
      //       easing: 'easeInOut',
      //       duration,
      //       color: '#FFEA82',
      //       trailColor: '#eee',
      //       trailWidth: 1,
      //       svgStyle: {width: '100%', height: '1%'}
      //     });
      //   }
      //   this.callsRunning.push("");
      //   if(this.callsRunning.length==1){
      //     this.barloading= setInterval(()=>{
      //       this.bardirection=!this.bardirection;
      //       this.bar.animate(this.bardirection?1:0)
      //     },duration+100)
      //   }
      // }catch(err){
      //   console.log('error', err)
      // }
    }
  }
  postActivitySearch(){
    try{
      this.callsRunning.pop();
      // if(!this.callsRunning.length){
      //   clearInterval(this.barloading);
      // }
    }catch(err){
      
    }
    
  }



  async mainSubscription(subscribeAnyway?:boolean){
    this.isLoadingActivities = true;
    this.isInitialized = false;
    const viewer = this.authenticationService.MeteorUser();
    this.viewer=viewer;


    const projectIdReactive = this.navParams.get('projectIdReactive');
    const projectId = (this.nextProject||{})._id || projectIdReactive && projectIdReactive.get();
    this.project = this.nextProject||this.projectService.getProject(projectId);
    this.company = this.project ? this.companyService.getCompany(this.project.companyId) : null;

    this.projectMembers = this.projectService.getProjectMembers(this.project);

    this.company = this.project ? this.companyService.getCompany(this.project.companyId) : null;
    this.updatePermissionParams();
    const requestedUserIdReactive = this.navParams.get('requestedUserIdReactive');
    const requestedUserId = requestedUserIdReactive && requestedUserIdReactive.get();
    const isProjectManager = this.project ? permissions.isProjectManager(this.project, viewer) : false;
    const isCompanyAdmin = this.company ? permissions.isCompanyAdmin(this.company, viewer) : false;
    const isSuperAdmin = permissions.isSuperAdmin(viewer);
    const assignedUserIds = [];
    this.hasPMDashboardTab = isCompanyAdmin || isProjectManager || isSuperAdmin;
    if(this.isDev == true) { console.log('cp2'); }

    if (this.project) {
      this.archivedUpdates = Updates.find({
        projectId: this.project._id,
        archived: true,
      }, {
        sort: {completionDate: -1},
      }).fetch();
    }
    this.userIdToView = viewer ? viewer._id : null;
    let userIdToView;
    if(isProjectManager || isCompanyAdmin || isSuperAdmin) {
      /* PMs/Admins can use the optional requestedUserId to show data for that specific user */
      const showEveryone = false;
      if(requestedUserId) {
        this.userIdToView = requestedUserId;
        userIdToView = requestedUserId;
      } else if(showEveryone) {
        this.userIdToView = null;
        userIdToView = null;
      }

    }

    if(this.isDev == true) { console.log('cp3'); }

      // MeteorObservable.subscribe('currentUpdateForProject', projectId).subscribe(this.calculateFilterCodeSections);
      if(subscribeAnyway){
        this.httpService.MeteorSubscribeAnyway('currentUpdateForProject', projectId);
      } else {
        this.httpService.MeteorSubscribe('currentUpdateForProject', projectId);
      }


      if(this.isDev == true) { console.log('cp4'); }

    this.currentUpdateId = this.project && this.project.currentUpdateId;

    console.log("this.currentupdate", projectId);
    const update = Updates.findOne({_id:this.currentUpdateId, archived:{$ne:true}});
    this.selectedUpdate = update;
    
    this.calculateFilterCodeSections()
    if(this.currentUpdateId !== this.loadedUpdateId) {
      this.isLoadingActivities = true;
       this.content.resize();

    }


    if(this.isDev == true) { console.log('cp5'); }

     if((this.previousUpdateId != this.currentUpdateId) && this.currentUpdateId) {
       this.preActivitySearch();
       console.log("searching activities main sub");
      this.httpService.MeteorCall("searchActivities",
        this.currentUpdateId,
        userIdToView ? [userIdToView] : [],
        this.filters,
        this.filterCodes,
        this.limit,
        this.limit + paginationLevel,
        this.sortField,
        this.sortAsc,
        this.filterText,
        this.wbs
       // await this.storage.get('wbs')
      ).then((res: any) => {
        console.log("searchActivitis", res)
        this.updatedActivities = {};
        this.previousUpdateId = this.currentUpdateId;
        this.i++;
        this.canLoadMore = res.length >= paginationLevel;

        if(this.isDev == true) { console.log("how many times is this request made", this.i, res) }
        this.originalActivities = res ? res.map(activity => this.activityService.getAugmentedActivity(activity)) || [] : [];
        this.activities = res ? res.map(activity => this.activityService.getAugmentedActivity(activity)) || [] : [];
        this.activity=this.activities.find(activity=>this.activity && (activity._id==this.activity._id));

        console.log("MAINSUBSCRIPIONACTIVITIES", this.activities)
        this.viewerHasActivities = this.activities.length > 0;
        this.isLoadingActivities = false;
        this.loadedUpdateId = this.currentUpdateId;
        this.isInitialized = true;
         this.content.resize();
         this.postActivitySearch();
      }).catch((e: Error) => {
        this.postActivitySearch();
        this.isLoadingActivities = false;
        if(this.isDev == true) { console.log("importnant error", e) }
      });
    }
    this.selectedUser = this.userIdToView ? Users.findOne(this.userIdToView) : this.authenticationService.MeteorUser();

    this.selectedUpdate = Updates.findOne({_id:this.currentUpdateId, archived:{$ne:true}});
     this.isLoadingActivities = false;
      this.content.resize();
  }


  ngOnInit() {
    this.showSort=true;
    this.user=this.authenticationService.MeteorUser();
    this.updatedActivities = {};
    if(this.isDev == true) { console.log('log activity details page'); }
    this.useOwnHeader = this.navParams.get('useOwnHeader');
    this.i = 0;
    this.isLoadingActivities = true;
    this.filterCodes = [];
    this.filters = {};
    this.activities = [];
    this.originalActivities = [];
    this.isInitialized = true;

    this.sharedService.updatePeriodGone.subscribe(
      (updatePeriod: any) => {
        if(this.project){
          this.project.currentUpdateId=undefined;
          this.currentUpdateId=undefined;
          this.selectedUpdate=undefined;
          this.activity=undefined;
          this.selectedActivity=undefined;
        }
        console.log("searching activities updatePeriodGone")
        this.mainSubscription().then(()=>this.httpService.privateLoopAction(true))
        .then(()=>this.mainSubscription())

      });
    // this.sharedService.projectChanged.subscribe(
    //   (project: any) => {
    //     this.project=project;
    //     this.nextProject=project;
    //     this.selectedUpdate=Updates.findOne({_id:(this.project && this.project.currentUpdateId), archived:{$ne:true}});
    //     console.log("searching activities projectChanged");
    //     this.mainSubscription().then(()=>this.httpService.privateLoopAction(true))
    //     .then(()=>this.mainSubscription());


    //   });
    if(this.isDev == true) { console.log('cp1'); }
    // this.sharedService.httpUpdate.subscribe(
    //   (res: any) => {
    //     // this.updatedActivities = {};
    //     // this.useOwnHeader = this.navParams.get('useOwnHeader');
    //     // this.i = 0;
    //     // let calledWithValues = false;
    //     // this.isLoadingActivities = true;
    //     // this.filterCodes = [];
    //     // this.filters = {};
    //     // this.activities = [];
    //     // this.originalActivities = [];
    //     // this.isInitialized = true;
    //     console.log("batman1")
    //     this.mainSubscription();
    //   }
    // )
    // MeteorObservable.autorun().subscribe(() => {
    //   this.mainSubscription();
    // });
    console.log("searching activities main");
    this.mainSubscription(true)

    if(this.isDev == true) { console.log('cp6'); }
  }
  calculateFilterCodeSections() {

    this.selectedUpdate = Updates.findOne({_id:this.currentUpdateId, archived:{$ne:true}});
    if(this.selectedUpdate && this.selectedUpdate._id && this.storedFilterMap && this.storedFilterMap[this.selectedUpdate._id]){
      return this.storedFilterMap[this.selectedUpdate._id];
    }

    this.filterCodeSections = DEFAULT_FILTER_SECTIONS
    console.log("this.selectedUpdate", this.selectedUpdate, this.currentUpdateId)
    if(this.selectedUpdate ) {
      (this.selectedUpdate.filteringCodesArray || []).forEach(filteringCode=>{
        const index = this.filterCodeSections.findIndex(existingCode=>existingCode.id===(filteringCode && String(filteringCode.actv_code_type_id)));
        const filter={
          id: filteringCode && String(filteringCode.actv_code_type_id),
          type: 'code',
          label: filteringCode.actv_code_type,
          multiselect: true, // should be true
          isCollapsed: true,
          options: (this.selectedUpdate && this.selectedUpdate.filteringActiveSubCodesArray && this.selectedUpdate.filteringActiveSubCodesArray.filter(subCode => {
            return subCode.actv_code_type_id === filteringCode.actv_code_type_id;
          }).map(subCode => {
            return { value: subCode && subCode.actv_code_id, label: subCode.actv_code_name };
          }).sort(function(a, b) {
            if(a.label < b.label) { return -1; }
            if(a.label > b.label) { return 1; }
            return 0;
          }))
        }

        console.log("this.selectedUpdate",index, filter)
        if(index>-1){
          this.filterCodeSections[index]=filter;
        }else{
          this.filterCodeSections=this.filterCodeSections.concat([filter])
        }
         this.content.resize();
      })

      const users = Users.find({ _id: { $in: Object.keys(this.selectedUpdate.subCodesByUser) } }).fetch();
      const myUser = this.authenticationService.MeteorUser();
      if(users && users.length && this.project && permissions.isProjectManager(this.project, myUser)) {
        console.log("this.usres", users)
        const userFilter={
          id: 'users',
          label: 'Updater',
          multiselect: true,
          isCollapsed: false,
          options: users.filter(user => {
            return this.project && !permissions.isProjectManager(this.project, user);
          }).map(user => {
            return { value: user._id, label: (user.profile && user.profile.name) || "Un-named User" }
          }).sort(function(a, b) {
            if(a.label < b.label) { return -1; }
            if(a.label > b.label) { return 1; }
            return 0;
          })
        }
        if(this.filterCodeSections[0].id!='users'){
          this.filterCodeSections.unshift(userFilter);
        } else {
          this.filterCodeSections[0] = userFilter;
        }
      }
      console.log("this.filtercodesections", this.filterCodeSections)
       this.content.resize();
      return this.filterCodeSections;
    }
    if(this.isDev == true) { console.log('cp3.5'); }
    return []
  }



  // @DAVIS, this is where you could get detail in accordion, likely not performant.
  getActivityFromWbsKey(wbsKey) {
    if(this.isDev == true) { console.log(this.activities.find(activity => activity.taskRow.wbs_name === wbsKey)) }
    if(this.isDev == true) { console.log('cp7'); }
  }
  wbsMode(wbs){
    this.wbs=wbs;
    this.populateActivities()
  }

  async populateActivities() {

    await this.findActivities();
    if(this.isDev == true) { console.log('cp8'); }
     this.content.resize();

  }

  pageScroller(){
    this.content.scrollToTop();
    console.log("Scroll function called")
    document.getElementById("scroll")
  }


  onClickSectionHeader(section) {
    section.isCollapsed = !section.isCollapsed;
  }

  onValueChange(section, option, newValue) {
    if(newValue === true && section.multiselect === false) {
      section.options=section.options.map(thisOption=>{
        thisOption.selected = false;
        if(thisOption.label===option.label && thisOption.value===option.value){
          thisOption.selected = newValue;
        }
        return thisOption;
      })
      option.selected = newValue;
    }

    this.filterSections=this.filterCodeSections.map(thisSection=>{
      if(thisSection.id===section.id){
        thisSection=section;
      }
      return thisSection
    })
    // this.filters,
    // this.filterCodes,
    this.didChangeFilters()
     this.content.resize();
  }


  getNumSelected(section) {
    return section.options.reduce((total, option) => {
      return total + (option.selected ? 1 : 0);
    }, 0);
  }
  isLevel1Shown(idx) {
   // return this.showLevel1 === idx;
  };




  // @wbs section with header functions and header update

  /** Header Functions For WBS inside Virtual Scroll */


  headerFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 1)
  }
  subHeaderFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 2)
  }

  subHeaderTwoFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 3)
  }

  subHeaderThreeFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 4)
  }

  subHeaderFourFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 5)
  }

  subHeaderFiveFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 6)
  }

  subHeaderSixFn(record, recordIndex, records) {
    return getHeaderForLevel(record, 7)
  }

  footerFn(record, recordIndex, records) {
    if(recordIndex % 1 === 0) {
      return null;
    }
    return null;
  }


  /** Updated virtual scroll list

    this.virtualScroll.readUpdate(true);
    this.virtualScroll.writeUpdate(true);

*/







  didNotChangeSort(sort1, sort2) {
    return Object.keys(sort1)[0] === Object.keys(sort2)[0] && sort1[Object.keys(sort1)[0]] == sort2[Object.keys(sort2)[0]]
  }

  async findActivities() {
    if(this.isDev == true) { console.log("finding activities", this.filterText) }


    const assignedUserIds = [];
    if(this.userIdToView) {
      assignedUserIds.push(this.userIdToView);
    }
    this.preActivitySearch();
    console.log("searching activities findActivities");
    return this.httpService.MeteorCall(
      'searchActivities',
      this.currentUpdateId,
      assignedUserIds,
      this.filters,
      this.filterCodes,
      0,
      paginationLevel,
      this.sortField,
      this.sortAsc,
      this.filterText,
      this.wbs
    ).then((res: any) => {

      this.updatedActivities = {};
      if(this.isDev == true) { console.log("retreived new activity query") }
      this.canLoadMore = res.length >= paginationLevel;
      this.activities = res.map(activity => this.activityService.getAugmentedActivity(activity)) || [];
      this.activity=this.activities.find(activity=>this.activity && (activity._id==this.activity._id));
      this.viewerHasActivities = this.activities.length > 0;
      this.isLoadingActivities = false;
      this.loadedUpdateId = this.currentUpdateId;
      this.content.resize();
      this.postActivitySearch();
    })
    .catch((e: Error) => {
      this.isLoadingActivities = false;
      if(this.isDev == true) { console.log("importnant error", e) }
    });
  }

  toggleFlag(activity: AugmentedActivity): void {
    const defaultFlaggedValue = !activity.isFlagged;
    /*
    MeteorObservable.call("setActivityFlag", activity._id, !activity.isFlagged).subscribe({
      next: (res: any) => {
        this.updatedActivities[activity._id] = { ...activity, isFlagged: !activity.isFlagged };
        this.showToast(defaultFlaggedValue ? 'Activity flag added' : 'Activity flag removed');
        this.activityPostAction(activity);
      }
    });
    */

    this.httpService.MeteorCall(
      'setActivityFlag',
      activity._id,
      !activity.isFlagged
    ).then((res: any) => {
      this.updatedActivities[activity._id] = { ...activity, isFlagged: !activity.isFlagged };
      this.activity.isFlagged=!activity.isFlagged;
      this.showToast(defaultFlaggedValue ? 'Activity flag added' : 'Activity flag removed');
    })
    .catch((e: Error) => {
      if(this.isDev == true) { console.log("importnant error", e) }
    });
  }

  /** BEGIN ActivityListHeaderBar **/

  onChangeSortField(newSortField: SortField): void {
    if(this.isDev == true) { console.log("sort field changed", newSortField) }
    this.sortField = newSortField;
    this.sortOptions=this.sortOptions.map(option=>{
      if(option.value===newSortField){
        option['selected']=true;
      } else {
        option['selected']=false;
      }
      return option;
    })
    this.populateActivities();

  }

  tracker(index, activity) {

    return activity._id;
  }

  toggleSortOrder(): void {

    this.sortAsc = !this.sortAsc;
    if(this.isDev == true) { console.log("sort field changed", this.sortAsc) }


    this.populateActivities();


  }

  runTextFilter(): void {
    if(this.isDev == true) { console.log("text filter submitted") }
    this.filterText = this.wipFilterText;
    this.closeTextFilter();
    this.content.resize();
    this.populateActivities();

  }

  clearSearch() {
    this.wipFilterText = '';
    this.filterText = '';
    this.content.resize();
    this.populateActivities();


  }

  showTextFilter(): void {
    this.isShowingTextFilter = true
    this.content.resize();
    this.populateActivities();

  }

  filterIsActive(): boolean {
    return !!(this.filterText && this.filterText.length) || !!(this.filterCodes && this.filterCodes.length) || !!(Object.keys(this.filters) || []).find(filter => {
      return Array.isArray(this.filters[filter]) ? this.filters[filter].length : (this.filters[filter] != null)
    })
  }

  closeTextFilter(event ? : Event): boolean {
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.wipFilterText = this.filterText;
    this.isShowingTextFilter = false;
    this.content.resize();
    this.populateActivities();

    return false;
  }


  getFiltersFromFilterSections(): Array < ActivityFilter > {

    return (this.filterSections.map(filterSection => {
      const selectedValues = (filterSection.options || []).filter(option => option.selected).map(option => option.value);
      if(this.isDev == true) { console.log('get filters from filter section: ' + filterSection.id + ' filter type: ' + selectedValues) };

      return {
        id: filterSection.id,
        type: filterSection.type === 'code' ? 'code' : 'normal',
        selectedValues,
      } as ActivityFilter;
    }) || []).filter(filter => filter.selectedValues.length > 0);

  }

  getLabelForSortValue(value, label: string): string {
    return (((this.sortOptions || []).find(sortOption => sortOption.value === value) || { value } || { label }).label)
  }

  didChangeFilters(): void {
    // this.filterSections = _.cloneDeep(this.calculateFilterCodeSections());

    // set for update _id

    

    if(this.isDev == true) { console.log("this.filterSections", this.filterSections) }
    this.filters = {};
    let filterCodes = [];
    this.filterSections.forEach(filterSection => {
      if(filterSection.multiselect) {
        this.filters[filterSection.id] = [];
      }
    })
    if(this.isDev == true) { console.log("this.filterSections", this.filterSections) }
    this.filterSections.forEach(filterSection => {

      const selected = (filterSection.options || []).filter(option => option.selected);
      if(filterSection.type != "code" && selected && selected.length) {
        if(!filterSection.multiselect) {
          this.filters[filterSection.id] = selected[0].value;
        } else {
          this.filters[filterSection.id] = selected.map(selectedObj => selectedObj.value);
        }
      } else if(filterSection.type === "code" && selected && selected.length) {
        filterCodes = filterCodes.concat(selected.map(selectedObj => {
          return {
            id: filterSection.id,
            value: selectedObj.value
          };
        }))
      }
    });
    if(this.selectedUpdate && this.selectedUpdate._id){
      this.storedFilterMap[this.selectedUpdate._id]=filterCodes;
    }
    this.filterCodes = filterCodes;
    this.populateActivities();
    this.filterMenuModal && this.filterMenuModal.dismiss();
    this.content.resize();


  }

  clearFilters() {
    if(this.isDev == true) { console.log("clearing filters") }
    this.filterSections = this.filterSections.map(section => {
      section.options = section.options.map(option => {
        option.selected = false;
        return option;
      })
      return section;
    });
    this.wipFilterSections = _.cloneDeep(this.filterSections);
    this.filterCodeSections = _.cloneDeep(this.filterSections);
    if(this.isDev == true) { console.log("this.filterCodeSections", this.filterCodeSections) }
    this.filterCodeSections = this.filterCodeSections.map(section => {
      section.options = section.options.map(option => {
        option.selected = false;
        return option;
      })
      return section;
    });
    this.filters = {};
    this.filterCodes = [];
    this.populateActivities();
    this.content.resize();


  }


  /** END ActivityListHeaderBar **/

  goToProgress(activity: AugmentedActivity): void {
    this.presentLoading()


    if(!this.selectedUpdate) {
      return;
    }

    const modal = this.modalCtrl.create(ActivityMenuComponent, { activityId: activity._id, updateId: this.selectedUpdate._id }, { enableBackdropDismiss: false });
    setTimeout(() => {
      modal.present();
    }, 500);
    modal.onDidDismiss((dismissedActivity) => {
      /*
      MeteorObservable.call("getActivity",
        activity._id,
      ).subscribe({
        next: (res: any) => {

          this.activities = this.activities.map(existingActivity => {
            if(existingActivity._id === res._id) {

              this.updatedActivities[activity._id] = { ...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              // existingActivity = {...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders};
            }
            return existingActivity;
          }) || [];

          this.viewerHasActivities = this.activities.length > 0;
          this.isLoadingActivities = false;
          this.loadedUpdateId = this.currentUpdateId;
        },
        error: (e: Error) => {
          if(this.isDev == true) { console.log("importnant error", e) }
        }
      });
      */

      this.httpService.MeteorCall('getActivity', activity._id)
        .then((res: any) => {
          this.activities = this.activities.map(existingActivity => {
            if(existingActivity._id === res._id) {

              this.updatedActivities[activity._id] = { ...this.activityService.getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              // existingActivity = {...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders};
            }
            return existingActivity;
          }) || [];

          this.viewerHasActivities = this.activities.length > 0;
          this.isLoadingActivities = false;
          this.loadedUpdateId = this.currentUpdateId;
        })
        .catch((e: Error) => {
          this.isLoadingActivities = false;
          if(this.isDev == true) { console.log("importnant error", e) }
        });
    });
  }

  goToLogs(logId ? : string): void {
    this.presentLoading()
    if(logId) {
      const modal = this.modalCtrl.create(ActivityLogsPage, {
        logId
      }, { enableBackdropDismiss: false });
      setTimeout(() => {
        modal.present();
      }, 500);
    }
  }

  goToLogMenu(activity: AugmentedActivity, slidingItem: ItemSliding, logId ? : string): void {
    if(this.isDev == true) { console.log("incoming project is ", (this.project as Project)._id) }
    this.presentLoading();

    const modal = this.modalCtrl.create(LogMenuComponent, {
      activityId: activity._id,
      p6ActivityId: activity.p6ActivityId,
      logId,
      projectId: (this.project as Project)._id,
      updateId: activity.updateId
    }, { enableBackdropDismiss: false });
    setTimeout(() => {
      modal.present();
    }, 500);


    modal.onDidDismiss((dismissedActivity) => {
      /*
      MeteorObservable.call("getActivity",
        activity._id
      ).subscribe({
        next: (res: any) => {
          if(this.isDev == true) { console.log("retreived new activity query", res) }
          this.activities = this.activities.map(existingActivity => {
            if(existingActivity._id === res._id) {
              this.updatedActivities[activity._id] = { ...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              // existingActivity = {...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders};
            }
            return existingActivity;
          }) || [];
          this.viewerHasActivities = this.activities.length > 0;
          this.isLoadingActivities = false;
          this.loadedUpdateId = this.currentUpdateId;
        },
        error: (e: Error) => {
          if(this.isDev == true) { console.log("importnant error", e) }
        }
      });
      */

      this.httpService.MeteorCall('getActivity', activity._id)
        .then((res: any) => {
          if(this.isDev == true) { console.log("retreived new activity query", res) }
          this.activities = this.activities.map(existingActivity => {
            if(existingActivity._id === res._id) {
              this.updatedActivities[activity._id] = { ...this.activityService.getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
              // existingActivity = {...getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders};
            }
            return existingActivity;
          }) || [];
          this.viewerHasActivities = this.activities.length > 0;
          this.isLoadingActivities = false;
          this.loadedUpdateId = this.currentUpdateId;

        })
        .catch((e: Error) => {
          if(this.isDev == true) { console.log("importnant error", e) }
        })
    });

  }

  share(slidingItem: ItemSliding) {
    slidingItem.close();

  }

  goToActivity(activity: AugmentedActivity, slidingItem: ItemSliding): void {
    this.presentLoading()
    if(activity) {


  /**  const modal = this.modalCtrl.create(ActivityDetailsPage, {
        activityId: activity._id,

      }, { enableBackdropDismiss: false });
      setTimeout(() => {
        modal.present();
      }, 500);
      modal.onDidDismiss((activity) => {


      });
      */
    }

  }

  canAddActivityLog(activity: AugmentedActivity): boolean {
    const validTaskTypes = ['TT_Task', 'TT_Rsrc', 'TT_Mile', 'TT_FinMile'];
    return _.includes(validTaskTypes, activity.taskType) && !activity.logId;
  }

  presentLoading(value:any={}) {
    const loader = this.loadingCtrl.create({
      content: value.content || "Please wait...",
      duration: value.duration || 500,
      enableBackdropDismiss: true,
    });
    loader.present();
  }

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message,
      duration: 2500,
      position: 'top',
      dismissOnPageChange: true,
    });

    toast.present();
    return toast;
  }


  handleError(err: Error): void {
    if(this.isDev == true) { console.error('ActivityList error: ', err); }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: err.message,
      title: 'Oops!'
    });

    alert.present();
  }
  getActivity(){
    return this.activity;
  }

  closeActivity(){
    this.activity=undefined;
    this.selectedActivity=undefined;
  }
  async activityClicked(activity: Activity): Promise<any> {
   this.isLoadingActivities = false;
    (activity as any).activate = !(activity as any).activate;
   this.update=this.selectedUpdate;
    if(this.selectedUpdate.updatePeriodType==="REMAINING_DURATION"){
      let durationOptions = Array.apply(null, {length: activity.originalDuration+1}).map(Number.call, Number)
      durationOptions.shift()
      this.durationOptions=durationOptions
      this.newRd=Number(activity.progressAmount || activity.originalDuration)
    } else {
      this.newRd=Number(activity.progressAmount)
    }

    this.activity=activity;

    this.selectedActivity=activity;
    let myDate = new Date()
    var tzo = (myDate.getTimezoneOffset() / 60) * (-1);
    myDate.setHours(myDate.getHours() + tzo)
    this.day = myDate;
    let calendarId = this.activity.taskRow.clndr_id; /* new */

    if(this.isDev == true) { console.log(this.selectedUpdate) }

    this.workDays = this.selectedUpdate.calendars[calendarId].workDays;
    this.exceptionDays = this.selectedUpdate.calendars[calendarId].exceptionDays;
    this.hrCount = this.selectedUpdate.calendars[calendarId].dayHrs;
    this.baselineRemainingDuration = (this.activity.taskRow.remain_drtn_hr_cnt / this.hrCount);
    this.percentComplete = Math.round(Math.round(100 * (1 - (this.activity.taskRow.remain_drtn_hr_cnt / this.activity.taskRow.target_drtn_hr_cnt))) / 5) * 5;

    console.log("this.day, this.activity, this.workDays, this.exceptionDays", this.day, this.activity, this.workDays, this.exceptionDays)

    try { this.getDayVsScheduledStart = getDayVsScheduledStart(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getDurationDelta = getDurationDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getStartDelta = getStartDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getFinishDelta = getFinishDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.finishDays = 1+daysBetween(this.activity.actualStart, this.activity.actualFinish, this.workDays, this.exceptionDays);} catch (err) {console.log(err)}
    try { this.getRemainingDurationInProgressProjectedFinish = getRemainingDurationInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getRemainingDurationInProgressFinishDelta = getRemainingDurationInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getRemainingDurationInProgressProjectedDuration = getRemainingDurationInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getRemainingDurationInProgressDurationDelta = getRemainingDurationInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getPercentCompleteInProgressProjectedFinish = getPercentCompleteInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getPercentCompleteInProgressFinishDelta = getPercentCompleteInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getPercentCompleteInProgressProjectedDuration = getPercentCompleteInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getPercentCompleteInProgressDurationDelta = getPercentCompleteInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log(err)}
    try { this.getDayVsScheduledEnd = getDayVsScheduledEnd(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {console.log("getDayVsScheduledEndgetDayVsScheduledEndgetDayVsScheduledEnd",this.day, this.activity, this.workDays, this.exceptionDays, err)}
    await this.httpService.MeteorSubscribe('logs', this.project && this.project._id, this.activity.p6ActivityId)
    await this.httpService.refreshSubscriptions();
    this.logs = await this.findLogs();
  }
  async clearProgress(activity){
    this.startEditsRunning.push("");
    this.finishEditsRunning.push("");
    this.durationEditsRunning.push("");
    await this.httpService.MeteorCall('updateActivityProgress',
            0,
            activity._id
          )
    await this.httpService.MeteorCall('removeActualFinish', activity._id);
    await this.httpService.MeteorCall('removeActualStart', activity._id);
    // may need something for PC
    await this.activityPostAction(activity);
    this.startEditsRunning.pop();
    this.finishEditsRunning.pop();
    this.durationEditsRunning.pop();
    await this.showToast('Progress Has Been Cleared');
  }

  async activityPostAction(activity){
    const res:any = await this.httpService.MeteorCall("getActivity",
      activity._id
    )
    if(this.isDev == true) { console.log("retreived new activity query", res) }
    this.activities = this.activities.map(existingActivity => {
      if(existingActivity._id === res._id) {
        this.updatedActivities[activity._id] = { ...this.activityService.getAugmentedActivity(res), wbsHeaders: (activity as any).wbsHeaders };
        this.activityClicked(this.updatedActivities[activity._id])
        existingActivity=this.updatedActivities[activity._id];
      }
      return existingActivity;
    }) || [];
    this.viewerHasActivities = this.activities.length > 0;
    this.isLoadingActivities = false;
    this.loadedUpdateId = this.currentUpdateId;
  }

    goToPrompts() {
 //  this.presentLoading();
    this.showPage = 'prompts';
  }

  startDateCalendar(activity){
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Change Start Date',
        pickMode: 'single',
        defaultScrollTo: this.activity.actualStart || new Date(),
        defaultDate: this.activity.actualStart || new Date(),
        from: moment(this.activity.actualStart || new Date()).subtract(3, 'months').toDate(),
        to: this.activity.actualFinish ? this.activity.actualFinish : new Date(),
        daysConfig: [{
          date: this.day,
          subTitle: 'Today',
          cssClass: this.activity.actualFinish ? 'actual-finish' : '',
          marked: true,
        }],
        closeLabel: 'Cancel',
        doneLabel: 'Done',
      }
    });

    myCalendar.onDidDismiss(async date => {
      // this.reminderDate = date ? new Date(date.time) : undefined;
      // alert(date)
      if(date){
        this.startEditsRunning.push("");
        await this.httpService.MeteorCall('updateActualStart',
          activity._id,
          
          date ? moment(date.time).startOf('day').toDate() : undefined,
        )

        await this.activityPostAction(activity);
        this.startEditsRunning.pop();

        await  this.showToast('Actual Start has been changed');
      }
    });

    myCalendar.present();
  }

  finishDateCalendar(activity){
    if(!(activity.actualStart || activity.taskType == 'TT_FinMile')){
      const alert = this.alertCtrl.create({
        buttons: ['OK'],
        message: 'Please add a start date first',
        title: 'Oops!'
      });

      alert.present();
      return;
    }
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Change Finish Date',
        pickMode: 'single',
        from: activity.actualStart ? new Date(activity.actualStart) : moment(this.activity.actualFinish ? this.activity.actualFinish : new Date()).subtract(3, 'months').toDate(),
        defaultScrollTo: this.activity.actualFinish ? this.activity.actualFinish : new Date(),
        defaultDate: this.activity.actualFinish ? this.activity.actualFinish : new Date(),
        to: new Date(),
        daysConfig: [{
          date: this.day,
          subTitle: 'Today',
          cssClass: this.activity.actualFinish ? 'actual-finish' : '',
          marked: true,
        }],
        closeLabel: 'Cancel',
        doneLabel: 'Done',
      }
    });

    myCalendar.onDidDismiss(async newActualFinish => {
      // this.reminderDate = date ? new Date(date.time) : undefined;
      // alert(date)
      if(newActualFinish){
        let duration = 0;
        if(this.update.updatePeriodType == 'PERCENT_COMPLETE'){
          duration=100;
        }
        this.finishEditsRunning.push("");
        this.durationEditsRunning.push("");
        await this.httpService.MeteorCall('updateActivityProgress',
          duration,
          activity._id
        )
        await this.httpService.MeteorCall('updateActualFinish',
          activity._id,
          newActualFinish ? moment(newActualFinish.time).startOf('day').toDate() : undefined,
        )
        await this.activityPostAction(activity);
        this.finishEditsRunning.pop();
        this.durationEditsRunning.pop();
        await  this.showToast('Actual Finish has been changed');
      }
    });

    myCalendar.present();
  }
  async changeActivityProgress(value){
    this.durationEditsRunning.push("");
    await this.httpService.MeteorCall('updateActivityProgress',
          value,
          this.activity._id
    )
    await this.activityPostAction(this.activity);
    this.durationEditsRunning.pop();
    if(this.update.updatePeriodType == 'REMAINING_DURATION'){
      await this.showToast('Remaining Duration has been updated');
    } else {
      await this.showToast('Percent change saved');
    }
  }

  async removeActualFinish(activity){
    this.finishEditsRunning.push("");
    this.durationEditsRunning.push("");
   await this.httpService.MeteorCall('updateActivityProgress',
            0,
            activity._id
          )
    await this.httpService.MeteorCall('removeActualFinish', activity._id);
    await this.activityPostAction(activity);
    this.finishEditsRunning.pop();
    this.durationEditsRunning.pop();
  }
  getUpdatedActivity(activity) {
    return this.updatedActivities ? (this.updatedActivities[activity._id] || activity) : activity;
  }

  onDone() {
    const cbOnDone = this.navParams.get('onDone');
    cbOnDone(); //.emit(this.sections);
  }
  absoluteValue(num) {
    return Math.abs(num).toFixed(0);
  }

  addLog(activity: AugmentedActivity, activityId, projectId, p6ActivityId): void {
    if(this.isDev == true) {
       console.log('activity ' + activityId);
       console.log('project ' + this.project);
       console.log('p6 ' + this.activity.p6ActivityId );
     }
      const modal = this.modalCtrl.create(NewLogComponent, {
        activityId: activity._id,
        projectId: activity.projectId,
        p6ActivityId: activity.p6ActivityId,
        updateId: activity.updateId
      }, { enableBackdropDismiss: true });
      modal.present();
      
      if (this.project) { // this.project may not be instantiated by the time this code runs, in a cold start
        if (this.project.name) {
          this.router.navigate([this.project.name, 'activities', 'addNewActivityLog']);
        }
      }

      modal.onDidDismiss(async res => {
        await this.activityPostAction(activity)
        this.httpService.MeteorSubscribe('logs', this.project && this.project._id, this.activity.p6ActivityId)
        await this.httpService.refreshSubscriptions();
        this.logs = await this.findLogs();

        if (this.project) { // this.project may not be instantiated by the time this code runs, in a cold start
          if (this.project.name) {
            this.router.navigate([this.project.name, 'activities']);
          }
        }
      })
   }
   async findLogs(): Promise<Array<Log & { updateId?: string, update?: Update }>> {
    if (!(this.project && this.project._id)) {
      return [];
    }

    let logs = Logs.find({
      projectId: (this.project && this.project._id),
      p6ActivityId: this.activity.p6ActivityId
    }).fetch();
    for(const i in logs){
      logs[i].featuredImage=logs[i].featuredImage?await this.authenticationService.imageConverter(logs[i].featuredImage):logs[i].featuredImage
    }
    const augmentedLogs: Array<Log & {updateId?: string, update?: Update }> = logs.map(log => {
      return {
        ...log,
        update:this.update,
        updateId:(this.project && this.project._id),
      };
    });

    return augmentedLogs;


  }
  goToLog(log): void {
    const modal = this.modalCtrl.create(LogView, { logId: log._id }, { enableBackdropDismiss: false });
    modal.present();
  }
  updatePermissionParams() {
    if (this.project && this.viewer && this.company) {
      this.isProjectManager = permissions.isProjectManager(this.project, this.viewer);
      this.isCompanyAdmin = permissions.isCompanyAdmin(this.company, this.viewer);
      this.isSuperAdmin = permissions.isSuperAdmin(this.viewer);
      this.canAddUsers =  this.isCompanyAdmin || this.isSuperAdmin;
      this.canRemoveUsers = this.isCompanyAdmin || this.isSuperAdmin;
    }
  }

  canMakeMemberProjectUpdater(member): boolean {
    if (!this.viewer || !this.project) {
      return false;
    }
    if (this.viewer._id === member._id) {
      // you can't demote yourself from PM to updater, but it's possible to make yourself an updater as the company admin/super admin?
      if (this.isProjectManager) {
        return false;
      }
      // you can't make yourself an updater if you're already an updater
      return !permissions.isProjectUpdater(this.project, member);
    }
    if (permissions.isProjectUpdater(this.project, member)) {
      return false;
    }
    return this.isCompanyAdmin || this.isSuperAdmin;
  }

  canMakeMemberProjectManager(member): boolean {
    if (!this.project) {
      return false;
    }
    if (permissions.isProjectManager(this.project, member)) {
      return false;
    }
    return (this.isCompanyAdmin || this.isSuperAdmin);
  }

  toggleMemberProfile(member: User){
    this.showProfileMap[member._id] = !this.showProfileMap[member._id];
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  makeProjectManager(member: User, event): void {
    if (event) {
      event.stopPropagation();
    }
    const projectId = this.project && this.project._id;
    if (!projectId) {
     if(this.isDev == true) {  console.warn('Missing project') }
      return;
    }

    this.httpService.MeteorCall('makeProjectManager', projectId, member._id).then(res=>{
      this.httpService.refreshSubscriptions();
      // this.presentLoading({duration: 3000,});
      setTimeout(()=>{this.mainSubscription()}, 1000); this.sharedService.httpUpdate.emit('user change?');});
  }

  demotePm(member): void {
    const projectId = this.project && this.project._id;
    if (!projectId) {
     if(this.isDev == true) {  console.warn('Missing project') }
      return;
    }

    this.httpService.MeteorCall('demotePm', projectId, member._id).then(res=>{
      this.httpService.refreshSubscriptions();
      // this.presentLoading({ duration: 3000,});
      setTimeout(()=>{this.mainSubscription()}, 1000); this.sharedService.httpUpdate.emit('user change?');});
  }

  getActivityUserName(activity){
    let user = Users.findOne({_id:activity.assignedUserId});
    return (user && user.profile) ? user.profile.name : '';
  }

  removeProjectMember(member): void {
    const projectId = this.project && this.project._id;
    if (!projectId) {
      if(this.isDev == true) { console.warn('Missing project') }
      return;
    }

    let userId = member._id;

    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to remove this user from the Project?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            this.httpService.MeteorCall('removeProjectMember', projectId, userId)
            .then(res=>{
              this.httpService.refreshSubscriptions()
              return alert.dismiss().then(res=>{
                // this.presentLoading({duration: 3000,});
                setTimeout(()=>{this.mainSubscription()}, 1000); this.sharedService.httpUpdate.emit('user change?');});
            });

            return false;
          }
        }
      ]
    });

    alert.present();
  }

  /** Does not include Cancel */
  getActionSheetItemsForUser(member: User) {
    const canMakeMemberPm = this.canMakeMemberProjectManager(member);
    const canMakeMemberUpdater = this.canMakeMemberProjectUpdater(member);
    const canRemoveUser = this.canRemoveUsers && this.viewer._id !== member._id;

    return _.compact([

      canMakeMemberPm && {
        text: 'Make PM',
        icon: 'star',
        handler: () => {
          this.makeProjectManager(member, event);
        }
      }, canMakeMemberUpdater && {
        text: 'Make Updater',
        icon: 'star-outline',
        handler: () => {
          this.demotePm(member);
        }
      }, canRemoveUser &&{
        text: 'Remove',
        icon: 'trash',
        handler: () => {
          this.removeProjectMember(member);
        }
      }
    ]);
  }

  canPresentActionSheetForUser(member: User): boolean {
    return this.getActionSheetItemsForUser(member).length > 0;
  }

  presentActionSheet(member: User, event) {
    if (event) {
      event.stopPropagation();
    }

    const actionSheet = this.actionSheetCtrl.create({
      title: '',
      buttons: [
        ...this.getActionSheetItemsForUser(member), {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => { },
        },
      ],
    });
    actionSheet.present();
  }

  goToAddProjectUser(project): void {
    const modal = this.modalCtrl.create(AddProjectUserComponent, {"project": this.project}, {enableBackdropDismiss: false});
    modal.present();

    if (this.project) { // this.project may not be instantiated by the time this code runs, in a cold start
      if (this.project.name) {
        this.router.navigate([this.project.name, 'noActiveUpdate', 'addProjectMember']);
      }
    }

    modal.onDidDismiss(() => {
      // this.presentLoading({duration: 3000,});
      this.sharedService.httpUpdate.emit('user change?')
      this.httpService.refreshSubscriptions()
      setTimeout(()=>{this.mainSubscription()}, 1000)

      if (this.project) {
        this.router.navigate([this.project.name, 'activities']);
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/activities.ts